import AcUnitIcon from '@mui/icons-material/AcUnit'
import BarChartIcon from '@mui/icons-material/BarChart'
import DashboardIcon from '@mui/icons-material/Dashboard'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import { routeFrontOfficeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeCommonUser'
import { routeFrontOfficeSchoolFormathequeCommonUser } from '@/lib/routes/front/common/routeFrontOfficeSchoolFormathequeCommonUser'
import { routesRewardsUser } from '@/lib/routes/front/getFrontOfficeInsightRewardsUser'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

export const getFrontOfficeSchoolPharmacienAndUserTeam = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    t: 'routes.frontoffice.school.dashboard',
    mobileText: 'Tableau de bord',
    icon: DashboardIcon,
    href: '/frontoffice/school/home',
    menuHeader: true,
    // Position 10 comme les autres entites : le tableau de bord ouvre TOUJOURS sa section.
    // A 100, il passait derriere « Pilotage de mon equipe » (20) et « Formations a
    // attribuer » (25), declarees dans getFrontOfficeSchoolManagerLearner.
    position: 10,
    isMobile: false,
  },
  // Formathèque : l'unique entrée « formations », qui ouvre sur ce qui reste à faire. Pages de
  // redirection plus bas (MyTodoTrainings, MyCompletedTrainings).
  ...routeFrontOfficeSchoolFormathequeCommonUser.map(route => ({
    ...route,
    home: true,
    position: 200,
    positionMobile: 100,
    // Menu v2 : remonte dans « Actions a faire » quand le badge est > 0.
    actionable: true,
    fnBadge: ({ dataMyProfile }) => {
      if (!dataMyProfile?.counterTaskEntityForMenu) return 0
      const counters = JSON.parse(dataMyProfile.counterTaskEntityForMenu)
      return (counters?.nbTrainingsEligible ?? 0) + (counters?.nbTrainingsToAssign ?? 0)
    },
  })),

  {
    route: 'SchoolAdventCalendar',
    text: "Calendrier de l'Avent",
    t: 'routes.frontoffice.school.adventCalendar',
    mobileText: "Calendrier de l'Avent",
    icon: AcUnitIcon,
    href: '/frontoffice/school/advent-calendar',
    menuHeader: true,
    position: 950,
    positionMobile: 450,
    // L'API decide seule : flag, France, hors admin, du 15 novembre au 25 decembre a la date du
    // calendrier (donc la date simulee en dev). Le front ne recode aucune date.
    fnDisplay: ({ dataMyProfile }: { dataMyProfile: any }) =>
      dataMyProfile?.schoolAdventSeason === true,
  },

  {
    route: 'Statistic',
    text: 'Statistiques',
    t: 'routes.frontoffice.school.statistics',
    mobileText: 'Statistiques',
    icon: BarChartIcon,
    href: '/frontoffice/school/statistic-school',
    menuHeader: true,
    position: 1000,
    positionMobile: 500,
  },
  {
    route: 'MyDiplomas',
    text: 'Mes Diplômes',
    t: 'routes.frontoffice.school.myDiplomas',
    mobileText: 'Mes Diplômes',
    icon: WorkspacePremiumIcon,
    href: '/frontoffice/school/diploma/my-diplomas',
    menuHeader: true,
    position: 1100,
    positionMobile: 600,
  },

  ...routeFrontOfficeCommonUser,
  {
    route: 'AllTrainings',
    href: '/frontoffice/school/training',
    menuHeader: false,
  },
  {
    route: 'TrainingDescription',
    href: '/frontoffice/school/training/[id]',
    menuHeader: false,
  },
  // Anciennes pages, désormais des sections de la Formathèque. Elles restent déclarées : un favori
  // ou une action « à faire » peut y pointer, et sans route withAuthent renverrait vers l'accueil.
  {
    route: 'MyTodoTrainings',
    href: '/frontoffice/school/training/my-todo-trainings',
    text: 'Mes formations à faire',
    t: 'routes.frontoffice.school.trainingTodo',
    menuHeader: false,
  },
  {
    route: 'MyCompletedTrainings',
    href: '/frontoffice/school/training/my-completed-trainings',
    text: 'Formations terminées',
    t: 'routes.frontoffice.school.trainingDone',
    menuHeader: false,
  },
  {
    route: 'ListIndustriesSchool',
    text: 'Liste des laboratoires',
    href: '/frontoffice/school/list-training-industries/[id]',
    menuHeader: false,
  },
  ...routesRewardsUser,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISCHOOL],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_USER_SCHOOL],
}))
